import BaseOptionsBundle from "%/dynamic-component-editor/classes/base-options";
import LayoutGap from "%/dynamic-component-editor/options/layout-gap";
import Overflow from "%/dynamic-component-editor/options/overflow";
import LayoutWidth from "%/dynamic-component-editor/options/layout-width";
import LayoutHeight from "%/dynamic-component-editor/options/layout-height";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import MaxWidth from "%/dynamic-component-editor/options/max-width";
import MaxHeight from "%/dynamic-component-editor/options/max-height";
import MinHeight from "%/dynamic-component-editor/options/min-height";
import MinWidth from "%/dynamic-component-editor/options/min-width";
import LayoutWrap from "%/dynamic-component-editor/options/layout-wrap";
import ScrunchWhenSqueezed from "%/dynamic-component-editor/options/scrunch-when-squeezed";
import StaticLayoutDirection from "%/dynamic-component-editor/options/static-layout-direction";
import LayoutAlign from "%/dynamic-component-editor/options/layout-align";
import LayoutAlignVertical from "%/dynamic-component-editor/options/layout-align-vertical";
import ScaleWidthAnchor from "%/dynamic-component-editor/options/scale-width-anchor";

export default class LayoutPositionOptions extends BaseOptionsBundle {
  optionTitle = "Layout";
  inspectorToolGroup = "layout";
  useInspectorLabel = false;
  static optionClassName = "i-dynamic-layout-position";
  static userInterfaceComponent = {
    component: inspectorTools.LAYOUT_POSITION_TOOL_SET,
  };

  constructor(values = {}) {
    super(values, [
      LayoutWidth,
      MaxWidth,
      MaxHeight,
      MinHeight,
      MinWidth,
      LayoutHeight,
      StaticLayoutDirection,
      LayoutAlign,
      LayoutAlignVertical,
      Overflow,
      LayoutGap,
      LayoutWrap,
      ScrunchWhenSqueezed,
      ScaleWidthAnchor,
    ]);
  }
}
